import React from "react";
import "./Checkbox.scss";

type Props = {
  checked?: boolean;
  name: string;

  onClick: any;
};

const CheckBox: React.FC<Props> = ({ checked, name, onClick, ...rest }) => {
  const makeCheckBox = () => {
    if (checked) {
      return <div className={`CheckBox checked`}></div>;
    } else {
      return <div className={`CheckBox`}></div>;
    }
  };
  return (
    <div className="CheckBoxWrapper" onClick={(e) => onClick(name)}>
      {makeCheckBox()}
    </div>
  );
};

export default React.memo(CheckBox);
